module.exports = __webpack_public_path__ + "public/images/header/logo-black.f5e85fda1f7508de0a436c8326422bd5.svg";